var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrainingRecord(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ffffff",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#ffffff;stroke-miterlimit:10;stroke-width:1.91px;}")), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.48,10.08A16.9,16.9,0,0,0,8.81,15.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.69,4.52a0,0,0,0,1,0,0,2.4,2.4,0,0,0-.18.89v4.65c0,3.82,2.86,12.41,5.73,12.41,5.5,0,9.5-4.94,11.33-7.71A4.77,4.77,0,1,0,13,10.09,14.12,14.12,0,0,0,10.09,12a4.9,4.9,0,0,0-1.28,3.7,8.07,8.07,0,0,0,.33,2"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 5.8,
    cy: 5.8,
    r: 4.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 5.8,
    cy: 5.8,
    r: 0.48
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingRecord);
export default __webpack_public_path__ + "static/media/training-record.4e63b4b6967c58e953a119b179d16341.svg";
export { ForwardRef as ReactComponent };